/**
 * Die Leistenzier-Varianten — bewusst OHNE "use client".
 *
 * `liesHuelle` (`lib/huellen-einstellung.ts`) prueft den Wert aus dem Keks gegen
 * diese Liste, und das auf dem SERVER (`theme-ssr.ts`). Bis 0.508.0 stand die
 * Liste in `Leistenzier.tsx`, einer Client-Datei: auf dem Server ist ein Export
 * von dort eine Client-Referenz, kein Array, und `ZIER_VARIANTEN.includes` warf
 * `TypeError` — jede Seite 500, sobald ein Konto eine Zier ausser „keine" hatte.
 * Waechter: `__tests__/server-weg-ohne-client-werte.test.ts`.
 */
export type ZierVariante = "linie" | "leiterbahn" | "ranke" | "naht" | "schichten";

/**
 * Die Reihenfolge, in der die Varianten angeboten werden — von der leisesten
 * zur lautesten. **Das ist die einzige Quelle der Auswahl**; die Bedienung
 * (`settings/HuellenAnsicht.tsx`) liest sie von hier und haengt „Keine" an.
 *
 * Bis 0.460.0 waren es sieben. Drei sind raus, und zwar auf Ansage des
 * Betreibers am 2026-09-19: „Faden find ich gar nicht geil", „Raster versteh
 * ich ganz und gar nicht, sieht komplett haesslich aus", „Silbe versteh ich
 * auch nicht wirklich". Eine Variante, die niemand versteht, ist kein Entwurf,
 * sondern eine Zeile Code.
 */
export const ZIER_VARIANTEN: readonly ZierVariante[] = [
  "linie",
  "leiterbahn",
  "ranke",
  "naht",
  "schichten",
];
